var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"loader-overlay"},[_c('div',{staticClass:"custom-loader"},_vm._l((4),function(n){return _c('div',{key:n,staticClass:"circle"},[_c('div',{staticClass:"dot"}),_c('div',{staticClass:"outline"})])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }